import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { AppointmentCreateComponent } from '../../../pages/dialogs/appointment-create/appointment-create.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DoctorService } from "../../../core/services/curd/doctor.service";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { PatientsService } from "../../../core/services/curd/patients.service";
import { ChannelingCenterService } from "../../../core/services/curd/channeling-center.service";
import { AppointmentsService } from "../../../core/services/curd/appointments.service";
import { formatDate } from "@angular/common";
import { ToastService } from '../../../core/services/misc/toast.service';
import { ApiService } from "../../../services/misc/api.service";
import { ApiOldDataService } from "../../../services/misc/api-old-data.service";
import Swal from 'sweetalert2';
import { TimeService } from "../../../core/services/curd/time.service";
import { AuthService } from 'src/app/core/services/misc/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

 country_list = ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua &amp; Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia &amp; Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Cape Verde", "Cayman Islands", "Chad", "Chile", "China", "Colombia", "Congo", "Cook Islands", "Costa Rica", "Cote D Ivoire", "Croatia", "Cruise Ship", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Kyrgyz Republic", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Mauritania", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Pierre &amp; Miquelon", "Samoa", "San Marino", "Satellite", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "South Africa", "South Korea", "Spain", "Sri Lanka", "St Kitts &amp; Nevis", "St Lucia", "St Vincent", "St. Lucia", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor L'Este", "Togo", "Tonga", "Trinidad &amp; Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks &amp; Caicos", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "Uruguay", "Uzbekistan", "Venezuela", "Vietnam", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"];
  countrySelected = 'Sri Lanka';
  filtered_countries_select: any = [];
  appointment_data: any = [];
  doctor_name: any;
  closeModal: string;
  patients_list: any = [];
  search_results: any = [];
  keyword = '';
  slot: any = {};
  page = 1;
  count = 0;
  tableSize = 10;
  phone_number_validation = false;
  id_number_validation = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;


  current_date = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US');
  selected_hospital = 'Select Hospital';
  hospitals: any = [];
  selected_slot:any = {};
  slot_list: any = [];


  patients_form = new FormGroup({
    name: new FormControl('', Validators.required),
    nic: new FormControl(''),
    clinic_no: new FormControl(''),
    mobile: new FormControl(''),
    dob: new FormControl(''),
    gender: new FormControl(''),
    address: new FormControl(''),
    city: new FormControl(''),
    country: new FormControl(''),
  });

  constructor(
    private router: Router,
    private matDialog: MatDialog,
    private doctorService: DoctorService,
    private modalService: NgbModal,
    private patientsService: PatientsService,
    private hospital: ChannelingCenterService,
    private booking: AppointmentsService,
    private toast: ToastService,
    private api: ApiService,
    private api_old: ApiOldDataService,
    private slot_service: TimeService

  ) {
  }

  ngOnInit(): void {
    this.loadDoctorInfo();
    this.loadPatients();
    this.loadCountriesSelect();
    // this.getSlotData()
    this.getHospitals();
  }

  loadAppintments(){
    //store selected slot data for future use
    let slot = this.slot_list.filter(obj => obj._id = this.selected_slot);
    slot = slot[0];
    let item = {
      slot_id: this.selected_slot,
      hospital: this.selected_hospital,
      date: this.current_date,
      slot: slot
    };

    console.log(item);

    localStorage.setItem('slotStore', JSON.stringify(item));

    this.router.navigate(['dashboard', 'NA', this.selected_slot, 'NA']);

    this.modalService.dismissAll();


  }

  resetSelects() {
    this.selected_hospital = 'Select Channeling Center';
    this.selected_slot = 'Select Slot';
  }

  getHospitals() {
    this.hospital.list().then(hospitals => {
      this.hospitals = hospitals;
    }).catch(e => {

    })
  }

  getTimeSlots() {

    this.slot_service.list().then(list => {
    //@ts-ignore
      this.slot_list = list.filter(obj => obj.channeling_center_name == this.selected_hospital && obj.date == this.current_date);
    }
    ).catch(e => console.log(e))
  }

  validationsCheck(value, type) {
    if (type == 'nic') {
      let id_number_value = value.target.value;
      if (id_number_value.length != 12) {
        this.id_number_validation = true;
      } else {
        this.id_number_validation = false;
      }
    }
    if (type == 'mobile_number') {
      let phone_number_value = value.target.value;
      if (phone_number_value.length != 10) {
        this.phone_number_validation = true;
      }
      else {
        this.phone_number_validation = false;
      }
    }
  }

  loadCountriesSelect() {
    this.filtered_countries_select = [];
    for (let country of this.country_list) {
      let select_item = {
        value: country,
        label: country,
        data: country
      }
      this.filtered_countries_select.push(select_item);
    }
  }

  profileInfo() {
    this.router.navigate(['doctor/profile'])
  }

  createAppointment() {
    const ref = this.matDialog.open(AppointmentCreateComponent, {
      panelClass: 'new-custom-test'
    });
  }

  loadDoctorInfo() {
    this.doctorService.list().then(res => {
      this.doctor_name = res[0].doctor_name;
    })
  }

  homePageLink() {
    this.router.navigate(['start'])
  }

  triggerModal(content, size = 'lg') {
    if (localStorage.getItem('slot') == undefined) {

    } else {

    }
    this.getSlotData();
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: size }).result.then((res) => {
      this.closeModal = `Closed with: ${res}`;
    }, (res) => {
      this.closeModal = `Dismissed ${this.getDismissReason(res)}`;
    });
  }


  async getSlotData() {
    // setInterval(async () => {
      let storage = await localStorage.getItem('slotStore');
      if (storage != 'undefined') {
        //@ts-ignore
        this.slot = JSON.parse(storage);
        console.log(this.slot);

      }
    // }, 1000);
  }


  async getSlotDataOld() {
    // setInterval(async () => {
      let storage = await localStorage.getItem('slot');
      if (storage != 'undefined') {
        //@ts-ignore
        this.slot = JSON.parse(storage);
        console.log(this.slot);

      }
    // }, 1000);
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  // toggleMenu() {
  //   let logo = document.getElementById('logo-img');
  //   let logo_sm = document.getElementById('logo-img-sm');
  //   let display = window.getComputedStyle(document.querySelector('#logo-img')).display
  //   if (display == 'inline') {
  //     logo.style.display = "none";
  //     logo_sm.style.display = "inline";
  //   } else {
  //     logo.style.display = "inline";
  //     logo_sm.style.display = "none";
  //   }
  //   document.body.classList.toggle('enlarge-menu');
  // }

  loadPatients() {
    this.patientsService.list().then(res => {
      this.patients_list = res;
    })
  }

  search() {
    this.patientsService.list().then(res => {
      this.patients_list = res;


      for (let item of this.patients_list) {
        let hasClinicNo = false; // Flag to check if the 'clinic_no' key exists
        for (let [key, value] of Object.entries(item)) {

          if (key === 'clinic_no') {
            hasClinicNo = true;
          }

          if (!value || value == undefined || value == null) {
            item[key] = '-';
          }

        }
        if (!hasClinicNo) {
          item['clinic_no'] = '';
        }
      }

      // this.search_results = this.patients_list.filter(
      //   obj => obj._doc.name.toUpperCase().includes(this.keyword.toUpperCase())
      //     || obj._doc.nic.toUpperCase().includes(this.keyword.toUpperCase())
      //     || obj._doc.mobile.includes(this.keyword)
      //     || obj._doc.clinic_no.toUpperCase().includes(this.keyword.toUpperCase())
      //     || obj._doc.patient_id.includes(this.keyword.toUpperCase())
      // );

      this.search_results = this.patients_list.filter(obj => {
        const doc = obj;

        return (
          (doc.name && doc.name.toUpperCase().includes(this.keyword.toUpperCase())) ||
          (doc.nic && doc.nic.toUpperCase().includes(this.keyword.toUpperCase())) ||
          (doc.mobile && doc.mobile.includes(this.keyword)) ||
          (doc.clinic_no && doc.clinic_no.toUpperCase().includes(this.keyword.toUpperCase())) ||
          (doc.patient_id && doc.patient_id.toUpperCase().includes(this.keyword.toUpperCase()))
        );
      });


      console.log(this.search_results);


      let keyword_check = this.keyword.substring(0, 2);

      if (keyword_check == '16' && this.search_results.length == 0) {

        Swal.fire({
          title: 'This patient not available in local database. Do you want to import from api system?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        }).then((result) => {
          if (result.isConfirmed) {

            this.api_old.apiGetPatientInfoByMedicalId(this.keyword);
          }
        })
      }
    });
  }


  updateAppointment(patient: any, has_next = false) {
    let hospital = this.slot.hospital;
    this.hospital.list().then(res => {
      // @ts-ignore
      res = res.filter(ob => ob.channeling_center_name == hospital)[0];
      const input = {
        status: 'created',
        token: 0,
        type: 'visit',
        channeling_center_name: hospital,
        channeling_center_id: res['_id'],
        slot_id: this.slot.slot_id,
        slot_date: this.slot.slot.date,
        visit_id: formatDate(Date.now(), 'yyMMddHHmmss', 'en-US'),
        patient_id: patient._id,
        patient_name: patient.name,
        medical_id: patient.patient_id,
        booking_name: '',
        booking_phone: '',
        synced: false
      };

      console.log(input);


      this.booking.create(input).then(data => {
        if (!has_next) {
          this.modalService.dismissAll();
        }
      })
    })
  }

  onTableDataChange(event) {
    this.page = event;
  }

  createNewAndLink(has_next) {
    let FLAG = true;

    if (this.patients_form.value.nic) {
      const filterd_patient_nic = this.patients_list.filter(obj => obj.nic == this.patients_form.value.nic)
      if (filterd_patient_nic.length != 0) {
        FLAG = false;
        this.toast.showError('Duplicate NIC')
      }
    }
    if (this.patients_form.value.mobile) {
      const filterd_patient_mobile = this.patients_list.filter(obj => obj.mobile == this.patients_form.value.mobile)
      if (filterd_patient_mobile.length != 0) {
        FLAG = false;
        this.toast.showError('Duplicate Mobile Number')
      }
    }

    if (FLAG) {
      this.store(has_next)
    }

  }

  store(has_next) {
    let date_id = formatDate(Date.now(), 'yyMMddHHmmss', 'en-US');
    date_id = date_id.replace(date_id.charAt(0), "1");
    const input_data = this.patients_form.value;
    input_data['patient_id'] = date_id;
    input_data['synced'] = false;
    this.patientsService.createWithOutToast(input_data).then(res => {
      const patient = {
        _id: res['data'],
        name: input_data.name,
        patient_id: date_id,
      }
      if (has_next) {
        this.patients_form.reset();
      }
      this.updateAppointment(patient, has_next);
      this.patients_form.patchValue({
        name: '',
        nic: '',
        mobile: '',
        dob: '',
        gender: '',
        address: '',
        city: '',
      })
    })
  }
}
